export class PrintRoomPropertiesMessage{
    public handled: boolean = false;

    constructor(value: boolean){
        this.handled = value;
    }

}
